import Vue from 'vue'
export default {
	setisNext(state,data){  //作业下一题按钮状态
		state.isNext = data
	},
    setisSubmit(state,data){//作业提交按钮状态
        state.isSubmit = data
    },
	setchapterid(state,data){//作业章节id
		state.chapterid = data
	},
	setreleaseid(state,data){//作业发布数据
		state.releaseid = data
	},
	picList(state,data){//作业发布
		state.picList = data
	},
	setBtnColor(state,data){
		state.btnColor.background = data
	}
}

